module.exports = __webpack_public_path__ + "0ac78923f58e0f28d00660861277eb46.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/dezeen.png
// module id = j01W
// module chunks = 0